import { type ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { useAuth } from 'contexts/AuthContext';
import { isTotadminUser } from 'utils/auth';

export function GuestGuard({ children }: { children: ReactNode }): ReactNode {
    const { user, loading } = useAuth();

    if (loading) return null;

    if (user && isTotadminUser(user)) {
        return <Navigate to="/" replace />;
    }

    return children;
}
